import { h, t, T, domWithScope } from '@jsx6/jsx6'
import { ChatBox } from '../ChatBox.js'
/**
 * 
 * @param {boolean} startBubble 
 * @param {ChatBox} chat 
 * @returns 
 */
export const areaButton = (startBubble, chat) => {
  return (
    <div p="area.button">
    {startBubble}
    <div
      class="start-chat-button btn-primary"
      p="buttonStartVideoId"
      icon="videoid"
      onclick={e => chat.start('chat_video_id')}
      hidden
      selector="--button-bg,--button-txt"
    ></div>
    <div
      class="start-chat-button btn-primary"
      p="buttonStartVideo"
      icon="video-call"
      onclick={e => chat.start('chat_video')}
      hidden
      selector="--button-bg,--button-txt"
    ></div>
    <div
      class="start-chat-button btn-primary"
      p="buttonStartAudio"
      icon="agent"
      onclick={e => chat.start('audio')}
      hidden
      selector="--button-bg,--button-txt"
    ></div>
    <div
      class="start-chat-button btn-primary"
      p="buttonStartText"
      icon="speech-bubble-comments-thin"
      onclick={e => chat.start('chat')}
      hidden
      selector="--button-bg,--button-txt"
    ></div>
  </div>
  )
}
